import { Heading, VStack } from '@gluestack-ui/themed';
import React from 'react';
import { 
  View, 
  Text, 
  StyleSheet, 
  TouchableOpacity, 
  StyleProp, 
  ViewStyle, 
  TextStyle 
} from 'react-native';

// 1. 📝 Definición de la Interfaz de Props
interface CustomTooltipOverlayProps {
  isVisible: boolean;
  onClose: () => void;
  title:string;
  content: string;
  width?: number;
  height?: number;
  x?: number;
  y?: number;
}

// 2. ⚛️ Componente de Tooltip Centrado (TSX)
const CustomTooltipOverlay: React.FC<CustomTooltipOverlayProps> = ({ 
  isVisible, 
  onClose, 
  content,width,height,x,y,title
}) => {
  if (!isVisible) {
    return null;
  }


  const styles = StyleSheet.create({
  // Contenedor principal: Ocupa toda la pantalla y usa Flexbox para centrar su contenido.
  absoluteFillCentered: {
    ...StyleSheet.absoluteFillObject as ViewStyle, // Assertion para garantizar el tipo
    position: 'absolute', 
    left: 0, 
    right: 0, 
    top: 0, 
    bottom: 0,
    width: width ?? 1000,
    height: height ?? 500,
    zIndex: 99999, 
  },
  backdrop: {
    // Es esencial para detectar el toque fuera del tooltip y debe cubrir toda la pantalla.
    ...StyleSheet.absoluteFillObject as ViewStyle,
    backgroundColor: 'transparent',  width: "100%",
    height:  "100%",
  },
  tooltipContainer: {
    backgroundColor: '#333',
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 15,
    width: (width-20)*3/4,
    top: (y ?? 100) - 50,
    marginHorizontal: (width - (width-20)*3/4) /2 ,
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tooltipText: {
    color: 'white',
    fontSize: 14,
    textAlign: 'center',
  },
});


  return (
    // La vista principal cubre toda la pantalla y tiene el Z-Index más alto.
    <View style={styles.absoluteFillCentered}>
        
      {/* Fondo (Para cerrar el tooltip al tocar fuera) */}
      <TouchableOpacity
        style={styles.backdrop}
        activeOpacity={1}
        onPress={onClose}
      />

      {/* Contenido del Tooltip (Centrado por el padre) */}
      <View style={styles.tooltipContainer}>
        <VStack>
            <Heading color="white" mb="2" size='sm' textAlign="center" borderBottomWidth={1} borderBottomColor="#fff">{title}</Heading>      
            <Text style={styles.tooltipText}>{content}</Text>
        </VStack>
        
      </View>
    </View>
  );
};

// 3. 🎨 Estilos con Type Safety

export default CustomTooltipOverlay;